/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { FSFBViewProto } from './fsfbview-proto';
import { RectStruct } from './rect-struct';

export class FSFBViewRootProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): FSFBViewRootProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsFSFBViewRootProto(
    bb: flatbuffers.ByteBuffer,
    obj?: FSFBViewRootProto,
  ): FSFBViewRootProto {
    return (obj || new FSFBViewRootProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsFSFBViewRootProto(
    bb: flatbuffers.ByteBuffer,
    obj?: FSFBViewRootProto,
  ): FSFBViewRootProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new FSFBViewRootProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  density(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  window(obj?: RectStruct): RectStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? (obj || new RectStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  insets(obj?: RectStruct): RectStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? (obj || new RectStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  topView(obj?: FSFBViewProto): FSFBViewProto | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new FSFBViewProto()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  static startFSFBViewRootProto(builder: flatbuffers.Builder) {
    builder.startObject(4);
  }

  static addDensity(builder: flatbuffers.Builder, density: number) {
    builder.addFieldInt32(0, density, 0);
  }

  static addWindow(builder: flatbuffers.Builder, windowOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, windowOffset, 0);
  }

  static addInsets(builder: flatbuffers.Builder, insetsOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, insetsOffset, 0);
  }

  static addTopView(builder: flatbuffers.Builder, topViewOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, topViewOffset, 0);
  }

  static endFSFBViewRootProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
